export const centerLatLng = {
    lat: 52.66260363906409,
    lng: -2.043800183378344,
}

export const initialMapOptions = {
    zoom: 8,
    center: centerLatLng,
}


// WEBPACK FOOTER //
// ./resources/assets/js/include/Map.js